var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubmitImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 230,
    height: 220,
    viewBox: "0 0 230 220",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_44",
    "data-name": "Rectangle 44",
    width: 230,
    height: 220,
    transform: "translate(1081 454)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_1",
    "data-name": "Mask Group 1",
    transform: "translate(-1081 -454)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "shadwork-logo",
    transform: "translate(1086.531 454)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1074",
    "data-name": "Path 1074",
    d: "M0,.321A224.121,224.121,0,0,1,27.205,47.652,224.522,224.522,0,0,1,42.563,102.74a201.761,201.761,0,0,0,.263-53.413A199.493,199.493,0,0,0,35.1,14.6Z",
    transform: "translate(0 -0.321)",
    fill: "#0d6986"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1075",
    "data-name": "Path 1075",
    d: "M20.623,33.021a199.327,199.327,0,0,1,39.294,7.8,197.985,197.985,0,0,1,69.966,38.033c-3.313-3.526-7.92-8.241-13.69-13.552A308.29,308.29,0,0,0,88.747,43.267C73.082,32.272,42.256,15.393,0,.321H0A200.933,200.933,0,0,1,11.672,17.244C15.095,22.752,18.057,28.085,20.623,33.021Z",
    transform: "translate(0 -0.321)",
    fill: "#0d6986"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1076",
    "data-name": "Path 1076",
    d: "M208.779,204.333a222.143,222.143,0,0,0-102.108-42.043,197.536,197.536,0,0,1,87.759,6.963Z",
    transform: "translate(10.159 15.667)",
    fill: "#0d6986"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1077",
    "data-name": "Path 1077",
    d: "M174,191.691a199.514,199.514,0,0,0-7.964-39.421A199.593,199.593,0,0,0,127.9,82.131c3.532,3.305,8.249,7.933,13.559,13.684a304.4,304.4,0,0,1,22.071,27.5c10.97,15.689,28.017,46.56,43.222,88.824h0c-5.024-3.768-10.663-7.69-16.916-11.546C184.334,197.2,179.025,194.247,174,191.691Z",
    transform: "translate(12.181 7.861)",
    fill: "#0d6986"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1078",
    "data-name": "Path 1078",
    d: "M0,210.192a239.262,239.262,0,0,0,28.3-52.62A241.278,241.278,0,0,0,42.651,100.28,340.615,340.615,0,0,1,44.428,144.7a340.351,340.351,0,0,1-3.357,39.862Z",
    transform: "translate(0 9.675)",
    fill: "#0d6986"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1079",
    "data-name": "Path 1079",
    d: "M0,204.38a237.8,237.8,0,0,1,109.436-42.726,336.9,336.9,0,0,0-83.942,1.5Q12.769,183.777,0,204.38Z",
    transform: "translate(0 15.62)",
    fill: "#0d6986"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmitImage);
export default __webpack_public_path__ + "static/media/submit_image.fcdfea6c8e92eb28c0fcd6a52e812b19.svg";
export { ForwardRef as ReactComponent };